import { makeStyles } from "@material-ui/core";
import moment from "moment";
import voca from "voca";

import { TransactionSign } from "../../settings/TransactionSign";
import { DDDD_MMMM_YYYY_HH_MM_FORMAT } from "../../settings/constants";
import Grid from "@material-ui/core/Grid";
import Typography from "@material-ui/core/Typography";
import CurrencyFormat from "react-currency-format";

interface TransactionRefundItemProps {
  cause: string;
  city: string;
  country: string;
  date: moment.Moment;
  category: string;
  amount: number;
  currency: string;
  sign: TransactionSign;
  refundedAmount: number;
}

const useStyles = makeStyles((theme) => ({
  cause: {
    fontSize: 16,
  },
  cityCountryDate: {
    fontSize: 14,
    color: theme.palette.grey[500],
  },
  category: {
    fontSize: 12,
    color: theme.palette.grey[500],
  },
  amountPlus: {
    fontSize: 16,
    fontWeight: "bold",
    color: "#36B516",
  },
  amountMinus: {
    fontSize: 16,
    fontWeight: "bold",
  },
}));

export const TransactionRefundItem = (props: TransactionRefundItemProps) => {
  const classes = useStyles();
  const {
    cause,
    city,
    country,
    date,
    category,
    amount,
    currency,
    sign,
    refundedAmount,
  } = props;

  return (
    <Grid container item xs={12}>
      <Grid item xs={5}>
        <Typography className={classes.cause} variant="h4" component="h4">
          {cause}
        </Typography>
      </Grid>
      <Grid item xs={2}>
        <Typography
          className={classes.cityCountryDate}
          variant="h5"
          component="h5"
        >
          {city},{country}
        </Typography>
      </Grid>
      <Grid item xs={2}>
        <Typography
          className={classes.cityCountryDate}
          variant="h5"
          component="h5"
        >
          {voca.titleCase(date.format(DDDD_MMMM_YYYY_HH_MM_FORMAT))}
        </Typography>
      </Grid>
      <Grid container item xs={3} spacing={3}>
        <Grid item xs={7} container alignItems="flex-end" justify="flex-end">
          <Typography className={classes.category} variant="h6" component="h6">
            {category}
          </Typography>
        </Grid>
        <Grid item xs={5}>
          <CurrencyFormat
            value={refundedAmount}
            prefix={currency}
            displayType="text"
            thousandSeparator={true}
            fixedDecimalScale={true}
            decimalScale={2}
            renderText={(formattedValue: string) => (
              <Typography
                className={
                  sign === TransactionSign.plus
                    ? classes.amountPlus
                    : classes.amountMinus
                }
                variant="h4"
                component="h4"
              >
                
                {formattedValue}
              </Typography>
            )}
          />
        </Grid>
      </Grid>
    </Grid>
  );
};
